/** 
 * [Ref] - Denotes Pseudo Code Reference
 * Author: Chandrasekar
 * Created Date: 07/30/2020
 * 
 * Import the necessary node-modules. If any of the nodes modules are not avaialble then 
 * install the node modules using the npm install command.
 * 
 * Ref: LN_PC_15
*/
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
/**
 * Ref: LN_PC_16
 * 
 * pageLoad method gets called from the componentWillMount() of the component.
 * It takes a parameters loginPageLoadBO which is passed from the component file.
 * @param loginPageLoadBO
 */
const pageLoad = (loginPageLoadBO) => {
    try {
        SDISVC.callGateway(
            SDIConstants.moduleNames.Login,
            SDIConstants.methodNames.getLoginOutageData,
            JSON.stringify(loginPageLoadBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.Login_Pageload, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/**
 * Ref: LN_PC_17
 * 
 * loginClick method gets called from the loginClick() of the component.
 * It takes a parameters loginClickBO which is passed from the component file.
 * @param loginClickBO
 */
const loginClick = (loginClickBO) => {
    try {
        SDISVC.login(
            loginClickBO,
            (data) => {
                ;
                if (data.success) {
                    if (data.response != "" && data.response) {
                        
                        let lastversion = CookieService.getLocalStorageValues("lastVersion");
                        CookieService.setCookieValues(SDIConstants.access_token, data.response.access_token, 30);
                        let userData = JSON.parse(data.response.userData);
                        userData = userData.LoginClickFlags_UpdatetoSession
                        if (userData.length > 0) {
                            userData = userData[0];
                        }
                        
                        console.log(userData)
                        //console.log("bgmlang1234", CookieService.getLocalStorageValues("newlanguage"))
                        let newlang = CookieService.getLocalStorageValues("newlanguage")
                       // console.log("bgmlang1234", CookieService.getLocalStorageValues("newlanguage"))
                        if (userData.Session_CONAME != null && userData.Session_CONAME != undefined) {
                            userData.Session_CONAME = userData.Session_CONAME.replace("–", "-");
                        }
                        let localStorageSuccess = CookieService.insertLocalStorageValues(userData);
                        CookieService.updateLocalStorageValues("newlanguage", newlang);
                        //console.log("bgmlang12345", CookieService.getLocalStorageValues("newlanguage"))
                        if (lastversion != undefined) {
                            CookieService.updateLocalStorageValues("lastVersion", lastversion);
                        }
                        CookieService.updateLocalStorageValues("currentversion", "4.0.1");
                        
                        if (localStorageSuccess) {

                            let tokenUpdateBO = {
                                userID: CookieService.getLocalStorageValues("Session_UserID"),
                                busUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                                accessMode: 2,
                                deviceInfo: "WebAPP",
                                expirySeconds: data.response.expires_in
                            }
                            //[10/3/22], PS_AT_02, WAL - Login authorization token (load balancer fix) - To hit mobile controller for access token, Dhevanesam R
                            SDISVC.callMobileGateway(
                                SDIConstants.moduleNames.Login,
                                SDIConstants.methodNames.Login_TokenUpdate,
                                JSON.stringify(tokenUpdateBO),
                                (data) => {
                                    if (data.success) {
                                        if (data.response != "" && data.response) {
                                            console.log(data.response);
                                            let contentData = { type: SDIConstants.methodNames.Login_TokenUpdate, response: data.response };
                                            Dispatcher.dispatch(contentData);
                                        }
                                    }
                                });
                        }
                    }
                } else if (data.success == false) {
                    let contentData = { type: "Login_Error", response: data.error.responseText };
                    Dispatcher.dispatch(contentData);
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const thirdPartyLogin = (email) => {
    try {
        SDISVC.callGateway(
            SDIConstants.moduleNames.Login,
            SDIConstants.methodNames.CheckThirdPatryID,
            email,
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ThirdPartyLogin", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
//PC_WW-617_28-Getting user contact details-Priyanka D
const getContactDetails = (BU) => {
    try {
        SDISVC.callGateway(
            SDIConstants.moduleNames.Login,
            SDIConstants.methodNames.getContactDetails,
            BU,
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "getContactDet", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
export { pageLoad, loginClick, thirdPartyLogin, getContactDetails }